/* Central Hype — Theme JS */

document.addEventListener('DOMContentLoaded', function () {

  // Search toggle
  const searchToggle = document.getElementById('search-toggle');
  const searchBar = document.getElementById('search-bar');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      searchBar.classList.toggle('active');
      if (searchBar.classList.contains('active')) {
        searchBar.querySelector('.search-input').focus();
      }
    });
  }

  // Mobile menu
  const menuToggle = document.getElementById('mobile-menu-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  const overlay = document.getElementById('mobile-overlay');

  function openMenu() {
    mobileNav.classList.add('open');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    mobileNav.classList.remove('open');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (menuToggle) menuToggle.addEventListener('click', openMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);

  // Header scroll effect
  const header = document.getElementById('site-header');
  let lastScroll = 0;
  window.addEventListener('scroll', function () {
    const currentScroll = window.pageYOffset;
    if (currentScroll > 80) {
      header.style.borderBottomColor = '#2a2a2a';
    } else {
      header.style.borderBottomColor = '#1a1a1a';
    }
    lastScroll = currentScroll;
  }, { passive: true });

  // Giveaway form
  const giveawayForm = document.getElementById('giveaway-form');
  const formArea = document.getElementById('giveaway-form-area');
  const successState = document.getElementById('giveaway-success');

  if (giveawayForm) {
    giveawayForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const name = document.getElementById('g-name').value.trim();
      const phone = document.getElementById('g-phone').value.trim();
      if (!name || !phone) {
        alert('Please enter your name and phone number to enter.');
        return;
      }
      if (formArea) formArea.style.display = 'none';
      if (successState) successState.style.display = 'block';
    });
  }

});
